import React, { FC } from 'react';
import { Text, Select, TextFieldSize } from '@bechtel/gds';
import { RodRoomAttendantSelectorProps } from './types';
import { useName } from '@bechtel/client-common';
import { t } from '@lingui/macro';
import { useQuery } from '@apollo/client';
import { GET_CREW_MEMBERS } from '@bechtel/client-gql';
import { CrewMember, CrewMemberList, PagingInput, PersonaType, SearchCrewMemberInput } from '@bechtel/types';
import { get } from 'lodash';
const RodRoomAttendantItem = ({ item }: any) => {
  const { getFullName } = useName();
  return (
    <Text size="400" color="grey.1000">
      {getFullName(item.firstName, item.lastName)}
    </Text>
  );
};

const RodRoomAttendantSelectedItem = ({ item }: any) => {
  const { getFullName } = useName();
  return (
    <Text size="400" color="grey.1000" family="graphik">
      {!item.firstName ? t`Select` : getFullName(item.firstName, item.lastName)}
    </Text>
  );
};

export const RodRoomAttendantSelector: FC<RodRoomAttendantSelectorProps> = ({
  selectedItem,
  onRodRoomAttendantSelection,
}) => {
  const { data, loading } = useQuery<
    { crewMembers: CrewMemberList },
    { input: SearchCrewMemberInput; paging: PagingInput }
  >(GET_CREW_MEMBERS, {
    variables: {
      input: {
        persona: PersonaType.ROD_ROOM_ATTENDANT,
      },
      paging: {
        cursor: '1',
        limit: 30,
      },
    },
  });

  const rodRoomAttendants: CrewMember[] = get(data, 'crewMembers.items', []) as CrewMemberList['items'];

  return (
    <Select
      selectedItem={selectedItem ? selectedItem : undefined}
      itemComponent={RodRoomAttendantItem}
      selectedComponent={RodRoomAttendantSelectedItem}
      size={TextFieldSize.LARGE}
      placeholder={t`Please Select`}
      items={rodRoomAttendants}
      onSelectedItemChange={async (changes) => {
        onRodRoomAttendantSelection(changes.selectedItem);
      }}
      loading={loading}
    />
  );
};
